module.exports = __webpack_public_path__ + "assets/tick.64a759ddddb4e0fd37e5717c51d434ae.png";